/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useState } from 'react';

import * as Styles from '@components/modals/styles';
import { ILooseObject } from '@interface/loose-object';
import { boardCreate } from '@lib/versum';
import { testNodeHealth } from '@utils/node';
import { AlertDialog, Field, Input, Textarea } from '@versumstudios/ui';

export interface IBoardCreate {
  open?: boolean;
  onOpenChange?: (value: boolean) => void;
  callback?: (result?: any) => void;
}

export const BoardCreate: FC<IBoardCreate> = ({ open, onOpenChange, callback }) => {
  const [values, setValues] = useState<ILooseObject>({
    title: { error: false, data: '' },
    description: { error: false, data: '' },
  });

  const handleChange = (key: string, value: any) => {
    setValues((prevValues) => ({
      ...prevValues,
      [key]: { error: false, data: value },
    }));
  };

  const setError = (key: string, message: string) => {
    setValues((prevValues) => ({
      ...prevValues,
      [key]: { error: message, data: prevValues[key].data },
    }));
  };

  const validate = () => {
    let valid = true;

    if (!values.title.data) {
      setError('title', '"Title" is missing');
      valid = false;
    }

    if (!values.description.data) {
      setError('description', '"Description" is missing');
      valid = false;
    }

    return valid;
  };

  const handleConfirm = async () => {
    if (validate()) {
      await testNodeHealth();
      boardCreate(values.title.data, values.description.data).then((result) => {
        if (callback) callback(result);
      });

      if (onOpenChange) {
        onOpenChange(false);
      }
    }
  };

  const handleCancel = () => {
    if (onOpenChange) {
      onOpenChange(false);
    }
  };

  return (
    <AlertDialog title="Create Board" open={open} onConfirm={handleConfirm} onCancel={handleCancel}>
      <Styles.Content>
        <Field uid="title" label="Title" error={values.title.error}>
          <Input
            type="text"
            placeholder="e.g.: Lorem ipsum"
            onChange={(value: string) => handleChange('title', value)}
          />
        </Field>
        <Field uid="description" label="Description" error={values.description.error}>
          <Textarea
            placeholder="e.g.: dolor sit amet"
            value={values.description.data}
            onChange={(value: string) => handleChange('description', value)}
          />
        </Field>
      </Styles.Content>
    </AlertDialog>
  );
};
